import React, { Component } from 'react';
import { connect } from 'react-redux';
import ErrorModal from './ErrorModal';
import ConfirmationModal from './ConfirmationModal';
import UpgradeCompanyModal from './UpgradeCompanyModal';
import GuestModal from './GuestModal';
import CompanySelectionModal from './CompanySelectionModal';
import SetPasswordModal from './SetPasswordModal';
import ConfirmYourEmailAddressModal from './ConfirmYourEmailAddressModal';
import DiscountModal from './DiscountModal';
import ConfirmPurchaseChoiceModal from './ConfirmPurchaseChoiceModal';
import InviteUsersModal from './InviteUsersModal';
import ContactSalesModal from './ContactSalesModal';
import BuyMoreLicensesOrSeatsModal from './BuyMoreLicensesOrSeatsModal';
import ReduceUsersModal from './ReduceUsersModal';
import PropTypes from 'prop-types';

const MODALS = {
	'ERROR_MODAL': ErrorModal,
	'CONFIRMATION_MODAL': ConfirmationModal,
	'UPGRADE_COMPANY_MODAL': UpgradeCompanyModal,
	'GUEST_MODAL': GuestModal,
	'COMPANY_SELECTION_MODAL': CompanySelectionModal,
	'SET_PASSWORD_MODAL': SetPasswordModal,
	'CONFIRM_YOUR_EMAIL_ADDRESS_MODAL': ConfirmYourEmailAddressModal,
	'DISCOUNT_MODAL': DiscountModal,
	'INVITE_USERS_MODAL': InviteUsersModal,
	'CONTACT_SALES_MODAL': ContactSalesModal,
	'CONFIRM_PURCHASE_CHOICE': ConfirmPurchaseChoiceModal,
	'BUY_MORE_LICENSES_OR_SEATS': BuyMoreLicensesOrSeatsModal,
	'REDUCE_USERS': ReduceUsersModal
};

class Modal extends Component {

	render() {
		const { modalType, modalProps } = this.props.modal;

		if (!modalType) {
			return null;
		}


		const SpecificModal = MODALS[modalType];
		return <SpecificModal {...modalProps} />;
	}

}

Modal.propTypes = {
	modal: PropTypes.object
};

const mapStateToProps = state => ({
	modal: state.modal
});

export default connect(
	mapStateToProps
)(Modal);


// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js